<template src="../templates/normal_fcont_144.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import AppDownloadPhotoPlusJp from '../components/AppDownloadPhotoPlusJp'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,AppDownloadPhotoPlusJp
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['144-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['144-2']}
      ]
    };
  }
  
};
</script>
<style >
</style>

